import { useCallback, useMemo, useState } from 'react';
import { querySqlPreview, type QuerySqlPreview } from 'src/components/star-grid/utils/querySqlPreview';

export const useQuerySqlPreview = (sql: string): { preview: QuerySqlPreview; expanded: boolean; toggle: () => void } => {
  const [expanded, setExpanded] = useState(false);
  const preview = useMemo(() => querySqlPreview(sql, expanded), [sql, expanded]);
  const toggle = useCallback(() => setExpanded((open) => !open), []);
  return { preview, expanded, toggle };
};
